// complex-tabs-utils.js
;(({ $, $$ }) => {
    const primaryComplexTabs = $$('.complex-lead-tab')

    updateCounterVisibility(primaryComplexTabs)   

    function updateCounterVisibility(tabButtons) {
        tabButtons.forEach(tab => {
            const counter = tab.querySelector('.complex-lead-tab__counter')
            if (!counter) return

            const counterValue = parseInt(counter.innerHTML.trim())
            
            counter.style.display = counterValue && counterValue > 0 ?
                'flex' : 'none'
        })
    }

    CNS.$fns.setPrimaryTabMessageCounterByIndex = function(index, count) {
        try {
            if (primaryComplexTabs[index]) {
                primaryComplexTabs[index].querySelector('.complex-lead-tab__counter')
                    .innerHTML = count
    
                updateCounterVisibility(primaryComplexTabs)
            }
        } catch (e) {
            console.warn(e)
        }
    }

    CNS.$fns.setPrimaryTabMessageCounterByName = function(name, count) {
        
        
        try {
            const tab = $(`.complex-lead-tab[data-tab-name="${name}"]`)
            if (!tab) { 
                console.warn(`Tab "${name}" not found`)
                return 
            }
            
            tab.querySelector('.complex-lead-tab__counter').innerHTML = count
            updateCounterVisibility(primaryComplexTabs)
        } catch (e) {
            console.warn(e)
        }
    }
})(CNS);
